module.exports = __webpack_public_path__ + "static/media/bouteille.e86cb345.svg";